var exports = {
  "Gh": "BlockedUsersTab.module__userList___dThDRD",
  "Kg": "BlockedUsersTab.module__userCard___dThDRD",
  "eF": "BlockedUsersTab.module__userInfo___dThDRD",
  "KI": "BlockedUsersTab.module__avatarButton___dThDRD",
  "xO": "BlockedUsersTab.module__usernameButton___dThDRD",
  "QV": "BlockedUsersTab.module__usernameContainer___dThDRD",
  "Xh": "BlockedUsersTab.module__username___dThDRD",
  "D2": "BlockedUsersTab.module__discriminator___dThDRD",
  "o1": "BlockedUsersTab.module__actions___dThDRD",
  "lK": "BlockedUsersTab.module__moreIcon___dThDRD",
};

module.exports = exports;
